import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { MinusIcon, PlusIcon } from "lucide-react";
import type { Product } from "../../types/product";
interface ProductDetailsProps {
  product: Product;
}
export function ProductDetails({
  product
}: ProductDetailsProps) {
  const sections = [{
    id: "usage",
    title: "How to use",
    content: product.usage
  }, ...(product.ingredients ? [{
    id: "ingredients",
    title: "Ingredients",
    content: product.ingredients
  }] : []), {
    id: "shipping",
    title: "Shipping & discretion",
    content: "Every order ships in plain, unbranded packaging from the Netherlands. Free shipping on orders over €50."
  }];
  const [open, setOpen] = useState<string>("usage");
  return <div className="border-t border-line" data-id="element-349" data-mp="dp680uv8eqbg">
      {sections.map(s => {
      const isOpen = open === s.id;
      return <div key={s.id} className="border-b border-line" data-id="element-350" data-mp="ioiwfk1r45g5">
            <h3 data-id="element-351" data-mp="iq3p144i9ebd">
              <button type="button" onClick={() => setOpen(isOpen ? "" : s.id)} aria-expanded={isOpen} aria-controls={`panel-${s.id}`} className="flex w-full items-center justify-between py-5 text-left font-semibold" data-id="element-352" data-mp="32xnbu72jxilo">
                {s.title}
                {isOpen ? <MinusIcon className="h-4 w-4" data-id="element-353" data-mp="37xi1k7alc255" /> : <PlusIcon className="h-4 w-4" data-id="element-354" data-mp="2k7fd015vxeba" />}
              </button>
            </h3>
            <AnimatePresence initial={false} data-id="element-355" data-mp="2k51jvxurmc6d">
              {isOpen && <motion.div id={`panel-${s.id}`} initial={{
            height: 0,
            opacity: 0
          }} animate={{
            height: "auto",
            opacity: 1
          }} exit={{
            height: 0,
            opacity: 0
          }} transition={{
            duration: 0.22,
            ease: [0.23, 1, 0.32, 1]
          }} className="overflow-hidden" data-id="element-356" data-mp="2f9vweulpspg6">
                  <p className="pb-5 text-sm leading-relaxed text-muted" data-id="element-357" data-mp="1wgs35acesem3">{s.content}</p>
                </motion.div>}
            </AnimatePresence>
          </div>;
    })}
    </div>;
}